import type { Point } from '../game/world-types.js';

/**
 * Pings: a player points at a spot or a unit for everyone in the room. They are talk between players, not orders: the server only
 * checks and relays them, and no rule ever reads them.
 */
export const PING_KINDS = ['mark', 'rally', 'attack', 'danger', 'watch', 'defend', 'heal'] as const;
export type PingKind = typeof PING_KINDS[number];
/** What a ping was dropped on, which decides the choices its wheel offers. */
export type PingSubject = 'ground' | 'enemy' | 'ally';
/** The wheel's choices on each subject; the first is the plain ping an Alt-click drops. */
export const PING_CHOICES: Record<PingSubject, readonly PingKind[]> = {
  ground: ['mark', 'rally', 'danger', 'watch'],
  enemy: ['mark', 'attack', 'danger', 'watch'],
  ally: ['mark', 'defend', 'heal'],
};
/** How long a ping shows, in seconds of real time (pings run while the game is paused). */
export const PING_SECONDS = 4;
/** At most this many pings per player in any window of `PING_WINDOW_MS`; the rest are dropped quietly. */
export const PING_BURST = 3;
export const PING_WINDOW_MS = 2000;

/** A ping as the server relays it. `mine` is true for the player who sent it. */
export interface PingMark { kind: PingKind; at: Point; targetId?: string; mine: boolean }

export const isPingKind = (value: unknown): value is PingKind => typeof value === 'string' && (PING_KINDS as readonly string[]).includes(value);
